@if (toolbarVisible) {
  <mat-toolbar class="art-piece-toolbar">
    <section class="toolbar-left">
      @if (!isArchive) {
        <button mat-flat-button type="button" class="create-btn" (click)="onCreateNewItem()">
          <mat-icon>add</mat-icon>
          <span>Create Art Piece</span>
        </button>
      }
      @if (canDeleteArtPiece && selectedArtPieceCount > 0) {
        <button
          mat-stroked-button
          class="secondary-btn delete-selected-btn"
          type="button"
          (click)="onToolbarDeleteSelected()"
        >
          <mat-icon>delete</mat-icon>
          <span>Delete</span>
        </button>
      }
      @if (isArchive) {
        <span class="archive-label">
          <mat-icon>archive</mat-icon>
          Art Piece Archive
        </span>
      }
    </section>
    <span class="toolbar-spacer"></span>
    <section class="toolbar-right">
      <div class="toolbar-item search-item">
        <dflow-search-tag (applyFilter)="applyTagsFilter($event)"></dflow-search-tag>
      </div>
      <mat-form-field appearance="outline" class="toolbar-field wide-field" (click)="newViewInput = false" subscriptSizing="dynamic">
        <mat-label>View</mat-label>
        <mat-select #select [(value)]="selectedViewLayout" [compareWith]="compareViewLayouts" (selectionChange)="onViewChange($event.value)">
          @for (viewLayout of viewLayouts; track viewLayout.layout_name) {
            <mat-option [value]="viewLayout">
              {{ viewLayout.layout_name }}@if (viewLayout.is_default) { (default) }
            </mat-option>
          }
          <div class="view-dropdown-actions" (click)="$event.stopPropagation()">
            @if (newViewInput) {
              <div class="new-view-input">
                <input #newView class="view-input" placeholder="Name your view" />
                <button mat-stroked-button color="primary" (click)="onSaveNewView(newView.value); newViewInput = false">Save</button>
              </div>
            }
            @if (!newViewInput) {
              <div class="view-btn-group">
                <button mat-button color="primary" (click)="onSaveLayout(selectedViewLayout)">Save current</button>
                <button mat-button color="primary" (click)="newViewInput = true">Add new</button>
                @if (selectedViewLayout?.layout_name !== 'Default' && !selectedViewLayout?.is_default) {
                  <button mat-button color="primary" (click)="onSetArtPieceViewAsDefault()">Set as default</button>
                }
                <button mat-button color="primary" (click)="onClearArtPieceDefaultView()" [disabled]="!hasArtPieceDefaultView()"
                  [matTooltip]="!hasArtPieceDefaultView() ? 'No default view is set — select a view and click \'Set as default\' first' : ''">Clear default</button>
              </div>
            }
          </div>
        </mat-select>
      </mat-form-field>
      <button mat-stroked-button type="button" class="secondary-btn" (click)="onBtExport()">
        <mat-icon>file_download</mat-icon>
        <span>Export</span>
      </button>
      <dflow-reset-aggrid-filters
        (resetClick)="resetFilters()"
        >
      </dflow-reset-aggrid-filters>
    </section>
  </mat-toolbar>
}
@if (gridApi) {
  <dflow-grid-active-chips
    [gridApi]="gridApi"
    (chipsVisibilityChange)="onChipsVisibilityChange($event)">
  </dflow-grid-active-chips>
}
<div class="grid-wrapper">
  <ag-grid-angular
    #agGrid
    id="myGrid"
    [style.height]="hasActiveChips ? 'calc(100vh - 216px)' : 'calc(100vh - 170px)'"
    [class]="gridClass"

    [pagination]="pagination"
    [paginationPageSize]="paginationPageSize"

    [defaultColDef]="defaultColDef"
    [gridOptions]="gridOptions"
    [rowModelType]="'serverSide'"

    [rowDragMultiRow]="true"
    [animateRows]="true"

    [groupDisplayType]="groupRows"
    [groupRowRendererParams]="groupRowRendererParams"

    [getRowId]="getRowNodeId"
    [getContextMenuItems]="getContextMenuItems"

    [components]="frameworkComponents"
    [detailRowHeight]="detailRowHeight"


    [columnTypes]="columnTypes"

    [undoRedoCellEditing]="true"
    [cacheQuickFilter]="true"
    [tooltipShowDelay]="tooltipShowDelay"
    [suppressScrollOnNewData]="true"

    [cacheBlockSize]="100"
    [maxBlocksInCache]="10"

    [debug]="true"

    (gridReady)="onGridReady($event)"
    (filterChanged)="onFilterChanged($event)"
    (columnMoved)="onColumnStateChanged($event)"
    (columnResized)="onColumnStateChanged($event)"
    (columnVisible)="onColumnStateChanged($event)"
    (columnPinned)="onColumnStateChanged($event)"

    >
  </ag-grid-angular>
</div>
